const variant = process.env.REACT_APP_PRODUCT_VARIANT ?? "default";

async function load(moduleName) {
	const loadVariant = async variant =>
		import(`./${variant}/${moduleName}.js`).then(module => {
			console.log(`Loaded "${variant}" variant of ${moduleName}`);
			return module;
		});

	return loadVariant(variant)
		.catch(() => loadVariant("default"))
		.then(module => (typeof module.default == "object" ? module.default : new module.default()));
}

export let BillOfMaterial;
export let Transactions;
export let WhereUsed;
export let StockOnHand;
export let Header;
export let Sourcing;
export let Reservations;
export let PM02Projection;
export let MaintenanceWorks;
export let SearchOptions;
export let PlantInfo;
export let ReturnsRatio;
export let Logo;
export let EntityLinks;
export let Description;
export let SearchTableColumns;
export let HersRecords;
export let Usage;
export let MaterialTabs;

export async function loadVariants() {
	BillOfMaterial = await load("BillOfMaterial");
	Transactions = await load("Transactions");
	WhereUsed = await load("WhereUsed");
	StockOnHand = await load("StockOnHand");
	Header = await load("Header");
	Sourcing = await load("Sourcing");
	Reservations = await load("Reservations");
	PM02Projection = await load("PM02Projection");
	MaintenanceWorks = await load("MaintenanceWorks");
	SearchOptions = await load("SearchOptions");
	PlantInfo = await load("PlantInfo");
	ReturnsRatio = await load("ReturnsRatio");
	Logo = await load("Logo");
	EntityLinks = await load("EntityLinks");
	Description = await load("Description");
	SearchTableColumns = await load("SearchTableColumns");
	HersRecords = await load("HersRecords");
	Usage = await load("Usage");
	MaterialTabs = await load("MaterialTabs");
}
